// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

/**
 * Design System theme object.
 *
 * Theme name: `current`
 *
 * Theme mode: `light`
 */
export default {
  borderRadius: {
    none: '0',
    default: '3px',
    circle: '50%',
    'button-radius-default': '3px',
    'button-radius-circle': '50%',
    container: '3px',
    input: '3px'
  },
  borderWidth: {
    none: '0',
    default: '1px',
    'alert-default': '1px',
    'alert-none': '0',
    'button-default': '1px'
  },
  color: {
    'border-default': '#CBD6E2',
    'border-subtle': '#DFE3EB',
    'border-table': '#DFE3EB',
    'border-selectable': '#7fd1de',
    'border-dropzone-idle': '#516F90',
    'border-dropzone-hover': '#00a4bd',
    'border-dropzone-procession': '#F5F8FA',
    'border-dropzone-error': '#D94C53',
    'border-active': '#00d0e480',
    'text-default': '#33475b',
    'text-subtle': '#516F90',
    'text-nonessential': '#7c98b6',
    'text-disabled': '#b0c1d4',
    'text-inverse': '#ffffff',
    'text-danger': '#F2545B',
    'text-success': '#00BDA5',
    'surface-default': '#ffffff',
    'surface-elevation1': '#F5F8FA',
    'surface-transparent': 'rgba(0, 0, 0, 0)',
    'action-text-default-idle': '#0091ae',
    'action-text-default-hover': '#007a8c',
    'action-text-default-pressed': '#7fd1de',
    'action-text-default-visited': '#0091ae',
    'action-text-visited': '#33475b',
    'action-text-disabled': '#b0c1d4',
    'action-text-danger-idle': '#F2545B',
    'action-text-danger-hover': '#D94C53',
    'action-text-danger-pressed': '#D94C53',
    'action-text-danger-visited': '#F2545B',
    'action-text-on-surface-idle': '#33475b',
    'action-text-on-surface-hover': '#33475b',
    'action-text-on-surface-pressed': '#33475b',
    'action-text-on-surface-visited': '#33475b',
    'action-text-inverse-idle': '#ffffff',
    'action-text-inverse-hover': '#7fd1de',
    'action-text-inverse-pressed': '#EAF0F6',
    'action-text-inverse-visited': '#ffffff',
    'action-icon-default': '#7C98B6',
    'action-icon-on-surface': '#33475b',
    'action-icon-inverse': '#ffffff',
    'action-icon-external': '#7C98B6',
    'alert-background-danger': '#FDEDEE',
    'alert-background-info': '#e5f5f8',
    'alert-background-warning': '#FEF8F0',
    'alert-background-success': '#E5F8F6',
    'alert-background-tip': '#ffffff',
    'alert-background-danger-loud': '#FFF1EE',
    'alert-background-info-loud': '#e5f5f8',
    'alert-background-warning-loud': '#fdf3e1',
    'alert-background-promo': 'linear-gradient(89deg, #FF7A59 0%, #F2547D 100% )',
    'alert-border-danger': '#F8A9AD',
    'alert-border-info': '#7fd1de',
    'alert-border-warning': '#FAE0B5',
    'alert-border-success': '#7FDED2',
    'alert-border-tip': '#7fd1de',
    'button-background-primary-idle': '#FF7A59',
    'button-background-primary-hover': '#ff8f73',
    'button-background-primary-pressed': '#E66E50',
    'button-background-neutral-default-idle': '#EAF0F6',
    'button-background-neutral-default-hover': '#F5F8FA',
    'button-background-neutral-default-pressed': '#CBD6E2',
    'button-background-neutral-dark-idle': '#425B76',
    'button-background-neutral-dark-hover': '#516F90',
    'button-background-neutral-dark-pressed': '#33475b',
    'button-background-neutral-light-idle': '#ffffff',
    'button-background-neutral-light-hover': '#F5F8FA',
    'button-background-neutral-light-pressed': '#CBD6E2',
    'button-background-secondary-idle': '#ffffff',
    'button-background-secondary-hover': '#fff8f6',
    'button-background-secondary-pressed': '#ffebe6',
    'button-background-danger-idle': '#F2545B',
    'button-background-danger-hover': '#ff5962',
    'button-background-danger-pressed': '#D94C53',
    'button-background-white-idle': '#ffffff',
    'button-background-white-hover': 'rgba(255, 255, 255, 0.9)',
    'button-background-white-pressed': 'rgba(255, 255, 255, 0.8)',
    'button-background-ghost-idle': 'rgba(255, 255, 255, 0)',
    'button-background-ghost-hover': 'rgba(255, 255, 255, 0.05)',
    'button-background-ghost-pressed': 'rgba(255, 255, 255, 0.10)',
    'button-background-disabled': '#EAF0F6',
    'button-background-transparent': 'rgba(0, 0, 0, 0)',
    'button-border-primary-idle': '#FF7A59',
    'button-border-primary-hover': '#ff8f73',
    'button-border-primary-pressed': '#E66E50',
    'button-border-neutral-default-idle': '#CBD6E2',
    'button-border-neutral-default-hover': '#CBD6E2',
    'button-border-neutral-default-pressed': '#7C98B6',
    'button-border-neutral-dark-idle': '#425B76',
    'button-border-neutral-dark-hover': '#516F90',
    'button-border-neutral-dark-pressed': '#33475b',
    'button-border-neutral-light-idle': '#CBD6E2',
    'button-border-neutral-light-hover': '#CBD6E2',
    'button-border-neutral-light-pressed': '#7C98B6',
    'button-border-secondary-idle': '#ff7a59',
    'button-border-secondary-hover': '#ff7a59',
    'button-border-secondary-pressed': '#ff7a59',
    'button-border-danger-idle': '#F2545B',
    'button-border-danger-hover': '#ff5962',
    'button-border-danger-pressed': '#D94C53',
    'button-border-transparent': 'rgba(0, 0, 0, 0)',
    'button-border-disabled': '#EAF0F6',
    'button-text-on-background-primary-default': '#ffffff',
    'button-text-on-background-neutral-default': '#506e91',
    'button-text-on-background-neutral-dark': '#ffffff',
    'button-text-on-background-neutral-light': '#506e91',
    'button-text-on-background-secondary-default': '#ff7a59',
    'button-text-on-background-danger-default': '#ffffff',
    'button-text-on-background-transparent-idle': '#0091ae',
    'button-text-on-background-transparent-hover': '#007a8c',
    'button-text-on-background-transparent-pressed': '#7fd1de',
    'button-text-on-background-white-default': '#33475b',
    'button-text-on-background-ghost-default': '#ffffff',
    'button-text-on-background-disabled': '#b0c1d4',
    'button-icon-secondary-default': '#ff7a59',
    'button-icon-danger-default': '#ffffff',
    'button-icon-transparent-default': '#7C98B6',
    'button-icon-white-default': '#33475b',
    'button-icon-ghost-default': '#ffffff',
    'button-icon-primary-default': '#ffffff',
    'button-icon-neutral-default': '#506e91',
    'button-icon-neutral-dark': '#ffffff',
    'button-icon-neutral-light': '#506e91',
    'button-icon-disabled': '#b0c1d4',
    'close-button-background-idle': 'rgba(255, 255, 255, 0)',
    'close-button-background-hover': 'rgba(255, 255, 255, .1)',
    'close-button-background-pressed': 'rgba(255, 255, 255, .1)',
    'close-button-background-focus': 'rgba(255, 255, 255, .1)',
    'close-button-background-disabled': 'rgba(255, 255, 255, 0)',
    'close-button-affordance-idle': 'rgba(255, 255, 255, 0)',
    'close-button-affordance-hover': 'rgba(255, 255, 255, .1)',
    'close-button-affordance-pressed': 'rgba(255, 255, 255, .1)',
    'close-button-affordance-focus': 'rgba(255, 255, 255, .1)',
    'close-button-affordance-disabled': 'rgba(255, 255, 255, 0)',
    'close-button-icon-default-idle': '#7C98B6',
    'close-button-icon-default-disabled': 'rgba(124, 152, 182, 0.6)',
    'close-button-icon-inverse-idle': '#ffffff',
    'close-button-icon-inverse-disabled': 'rgba(255,255,255, 0.6)',
    'container-background': '#ffffff',
    'tag-border-default': '#7C98B6',
    'tag-border-success': '#00BDA5',
    'tag-border-warning': '#F5C26B',
    'tag-border-danger': '#F2545B',
    'tag-border-info': '#00a4bd',
    'tag-border-accent-light-orange': '#FF8F59',
    'tag-border-accent-orange': '#FF7A59',
    'tag-border-accent-magenta': '#F2547D',
    'tag-border-accent-purple': '#6A78D1',
    'tag-background-default': '#F5F8FA',
    'tag-background-success': '#E5F8F6',
    'tag-background-warning': '#FEF8F0',
    'tag-background-danger': '#FDEDEE',
    'tag-background-info': '#e5f5f8',
    'tag-background-accent-light-orange': '#FFF3EE',
    'tag-background-accent-orange': '#FFF1EE',
    'tag-background-accent-magenta': '#FDEDF2',
    'tag-background-accent-purple': '#F0F1FA',
    'input-background-default': '#F5F8FA',
    'input-background-disabled': '#EAF0F6',
    'input-background-read-only': '#EAF0F6',
    'input-background-on-surface': '#ffffff',
    'input-border-idle': '#CBD6E2',
    'input-border-disabled': '#EAF0F6',
    'input-border-read-only': '#EAF0F6',
    'input-text-entered': '#33475b',
    'input-text-placeholder': '#7c98b6',
    'input-text-disabled': '#b0c1d4',
    'interactive-ui-background-transparent': 'rgba(255, 255, 255, 0)',
    'interactive-ui-background-action': '#e5f5f8',
    'interactive-ui-background-noninteractive': '#EAF0F6',
    'interactive-ui-text-default': '#33475b',
    'interactive-ui-text-disabled': '#b0c1d4',
    'interactive-ui-action-idle': '#0091ae',
    'interactive-ui-action-hover': '#007a8c',
    'interactive-ui-action-pressed': '#7fd1de',
    'interactive-ui-icon-default': '#0091ae',
    'interactive-ui-icon-external': '#7C98B6',
    'interactive-ui-icon-body': '#33475b',
    'interactive-ui-border-action': '#7fd1de',
    'selectable-item-background-idle': 'rgba(255, 255, 255, 0)',
    'selectable-item-background-hover': '#e5f5f8',
    'selectable-item-background-pressed': '#e5f5f8',
    'selectable-item-background-selected': '#e5f5f8',
    'selectable-item-background-disabled': 'rgba(255, 255, 255, 0)',
    'selectable-item-background-selecteddisabled': '#e5f5f8',
    'selectable-item-text-body-idle': '#33475b',
    'selectable-item-text-body-hover': '#33475b',
    'selectable-item-text-body-pressed': '#33475b',
    'selectable-item-text-body-selected': '#33475b',
    'selectable-item-text-body-disabled': '#b0c1d4',
    'selectable-item-text-body-selecteddisabled': '#b0c1d4',
    'selectable-item-text-action-idle': '#0091ae',
    'selectable-item-text-action-hover': '#007a8c',
    'selectable-item-text-action-pressed': '#7fd1de',
    'selectable-item-text-action-selected': '#0091ae',
    'selectable-item-text-action-disabled': '#b0c1d4',
    'selectable-item-text-action-selecteddisabled': '#b0c1d4',
    'selectable-item-icon-action-idle': '#0091ae',
    'selectable-item-icon-action-hover': '#0091ae',
    'selectable-item-icon-action-pressed': '#0091ae',
    'selectable-item-icon-action-selected': '#0091ae',
    'selectable-item-icon-action-disabled': '#0091ae',
    'selectable-item-icon-action-selecteddisabled': '#0091ae',
    'selectable-item-icon-body-idle': '#33475b',
    'selectable-item-icon-body-hover': '#33475b',
    'selectable-item-icon-body-pressed': '#33475b',
    'selectable-item-icon-body-selected': '#33475b',
    'selectable-item-icon-body-disabled': '#b0c1d4',
    'selectable-item-icon-body-selecteddisabled': '#b0c1d4',
    'selectable-item-icon-external-idle': '#7C98B6',
    'selectable-item-indicator-selected': '#00a4bd',
    'selectable-box-background-idle': 'rgba(255, 255, 255, 0)',
    'selectable-box-background-hover': 'rgba(255, 255, 255, 0)',
    'selectable-box-background-pressed': '#e5f5f8',
    'selectable-box-border-idle': '#7fd1de',
    'selectable-box-border-hover': '#7fd1de',
    'selectable-box-border-pressed': '#7fd1de'
  },
  fontFamily: {
    code: 'Source Code Pro, Consolas, Monaco, Courier New, monospace',
    default: 'Lexend Deca, Helvetica, Arial, sans-serif',
    'body-fallback': 'Helvetica, Arial, sans-serif',
    'monospace-fallback': 'Consolas, Monaco, Courier New, monospace'
  },
  fontWeight: {
    'body-default': '300',
    'body-bold': '600',
    'display-light': '300',
    'display-medium': '500',
    'display-default': '600',
    'display-bold': '700',
    'code-default': '500',
    'action-default': '600'
  },
  size: {
    'icon-200': '8px',
    'icon-300': '12px',
    'icon-350': '14px',
    'icon-400': '16px',
    'icon-450': '18px',
    'icon-500': '20px',
    'icon-600': '24px',
    'icon-700': '28px',
    'icon-800': '32px',
    'accordion-icon-width-medium': '9px',
    'accordion-icon-width-extra-large': '11px',
    'accordion-icon-width-large': '11px',
    'accordion-icon-width-small': '7px',
    'accordion-icon-width-extra-small': '5px',
    'accordion-icon-height-medium': '16px',
    'accordion-icon-height-extra-large': '20px',
    'accordion-icon-height-large': '20px',
    'accordion-icon-height-small': '12px',
    'accordion-icon-height-extra-small': '10px',
    'alert-min-height-compact': '44px',
    'alert-min-height-default': '60px',
    'button-icon-default': '14px',
    'button-icon-small': '12px',
    'button-icon-extra-small': '12px',
    'icon-button-width-default': '40px',
    'icon-button-width-small': '32px',
    'icon-button-width-extra-small': '26px',
    'close-button-icon-small': '8px',
    'close-button-icon-medium': '12px',
    'close-button-icon-large': '16px',
    'close-button-icon-extra-large': '36px',
    'close-button-affordance-small': '2',
    'close-button-affordance-medium': '2',
    'close-button-affordance-large': '32px',
    'close-button-affordance-extra-large': '72px',
    'focus-width-default': '2px',
    'focus-offset-default': '1px',
    'input-height-default': '40px',
    'input-height-small': '32px',
    'input-icon-default': '16px',
    'input-icon-small': '14px',
    'selectable-item-min-height': '40px'
  },
  lineHeight: {
    'body-default': '24px',
    'body-tight': '18px',
    display: '1.2',
    code: '24px',
    'button-default': '16px',
    'button-small': '14px',
    'button-extra-small': '14px'
  },
  space: {
    '50': '2px',
    '100': '4px',
    '150': '6px',
    '200': '8px',
    '250': '10px',
    '300': '12px',
    '350': '14px',
    '400': '16px',
    '450': '18px',
    '500': '20px',
    '600': '24px',
    '700': '28px',
    '800': '32px',
    '900': '36px',
    '1000': '40px',
    '1100': '44px',
    '1200': '48px',
    '1300': '52px',
    '1400': '56px',
    '1500': '60px',
    none: '0',
    'accordion-title-padding-inline-start-medium': '24px',
    'accordion-title-padding-inline-start-extra-large': '28px',
    'accordion-title-padding-inline-start-large': '28px',
    'accordion-title-padding-inline-start-small': '20px',
    'accordion-title-padding-inline-start-extra-small': '16px',
    'accordion-title-padding-block-end-medium': '16px',
    'accordion-title-padding-block-end-extra-large': '16px',
    'accordion-title-padding-block-end-large': '16px',
    'accordion-title-padding-block-end-small': '16px',
    'accordion-title-padding-block-end-extra-small': '8px',
    'accordion-content-padding-inline-start-medium': '24px',
    'accordion-content-padding-inline-start-extra-large': '28px',
    'accordion-content-padding-inline-start-large': '28px',
    'accordion-content-padding-inline-start-small': '20px',
    'accordion-content-padding-inline-start-extra-small': '16px',
    'accordion-gap-inline': '12px',
    'action-gap-default': '0.5em',
    'action-gap-external-icon': '0.25em',
    'alert-padding-block-default': '8px',
    'alert-padding-inline-default': '20px',
    'alert-gap-inline-default': '20px',
    'alert-gap-block-default': '8px',
    'button-padding-inline-default': '24px',
    'button-padding-inline-small': '16px',
    'button-padding-inline-extra-small': '12px',
    'button-padding-inline-transparent-default': '12px',
    'button-padding-inline-transparent-small': '8px',
    'button-padding-inline-transparent-extra-small': '6px',
    'button-padding-block-default': '11px',
    'button-padding-block-small': '8px',
    'button-padding-block-extra-small': '5px',
    'button-gap-default': '7px',
    'button-gap-small': '6px',
    'button-gap-extra-small': '6px',
    'close-button-padding-small': '4px',
    'close-button-padding-medium': '6px',
    'close-button-padding-large': '8px',
    'close-button-padding-extra-large': '18px',
    'card-padding-block-default': '40px',
    'card-padding-block-compact': '24px',
    'card-padding-inline-default': '40px',
    'card-padding-inline-compact': '24px',
    'tile-padding-block-default': '32px',
    'tile-padding-block-compact': '20px',
    'tile-padding-inline-default': '32px',
    'tile-padding-inline-compact': '20px',
    'tile-margin-block-flush': '0',
    'tile-margin-block-extra-small': '8px',
    'tile-margin-block-small': '12px',
    'tile-margin-block-medium': '24px',
    'tile-margin-block-large': '32px',
    'tile-margin-block-extra-large': '64px',
    'column-padding-block-default': '16px',
    'column-padding-block-none': '0',
    'column-padding-inline-default': '24px',
    'column-padding-inline-none': '0',
    'input-padding-block-default': '9px',
    'input-padding-block-small': '4px',
    'input-padding-inline-default': '10px',
    'input-padding-inline-small': '10px',
    'input-gap-inline-default': '10px',
    'input-gap-inline-small': '10px',
    'input-label-margin-block-default': '4px',
    'selectable-item-padding-inline-default': '20px',
    'selectable-item-padding-nested': '40px',
    'selectable-item-padding-block-default': '8px',
    'selectable-item-gap': '8px'
  },
  typography: {
    'action-default': {
      fontWeight: '600',
      lineHeight: 'inherit',
      textDecoration: 'none',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px'
    },
    'action-underline': {
      fontWeight: '600',
      lineHeight: 'inherit',
      textDecoration: 'underline',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px'
    },
    'action-small': {
      fontWeight: '600',
      lineHeight: 'inherit',
      textDecoration: 'none',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px'
    },
    'alert-title': {
      lineHeight: '1.2',
      fontWeight: '600',
      fontSize: '16px',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif'
    },
    'alert-text': {
      lineHeight: '1.4',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '14px'
    },
    'button-default': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      lineHeight: '16px',
      fontSize: '14px'
    },
    'button-small': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '14px',
      fontSize: '12px'
    },
    'button-extra-small': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '14px',
      fontSize: '12px'
    },
    'button-transparent-default': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '16px',
      fontSize: '14px',
      fontWeight: '600'
    },
    'button-transparent-small': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '14px',
      fontSize: '12px',
      fontWeight: '600'
    },
    'button-transparent-extra-small': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '14px',
      fontSize: '12px',
      fontWeight: '600'
    },
    'card-heading-extra-large': {
      lineHeight: '1.2',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '700',
      fontSize: '32px'
    },
    'card-heading-large': {
      lineHeight: '1.2',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '24px'
    },
    'card-heading-medium': {
      lineHeight: '1.2',
      fontSize: '20px',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '600'
    },
    'card-heading-small': {
      lineHeight: '1.2',
      fontWeight: '600',
      fontSize: '16px',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif'
    },
    'card-heading-extra-small': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '24px',
      fontSize: '14px'
    },
    'input-text-default': {
      lineHeight: '22px',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '16px'
    },
    'input-text-small': {
      lineHeight: '22px',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '14px'
    },
    'label-default': {
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '24px',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif'
    },
    'label-small': {
      fontWeight: '500',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '24px',
      fontSize: '12px'
    },
    'selectable-item-item-default': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '24px',
      fontSize: '14px'
    },
    'selectable-item-title': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '600',
      lineHeight: '24px',
      fontSize: '14px'
    },
    'text-body': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '24px',
      fontSize: '14px'
    },
    'text-body-large': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '24px',
      fontSize: '16px'
    },
    'text-body-small': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '18px',
      fontSize: '12px'
    },
    'text-microcopy': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      lineHeight: '18px',
      fontSize: '12px'
    },
    'text-code': {
      fontFamily: 'Source Code Pro, Consolas, Monaco, Courier New, monospace',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '24px'
    },
    'display-heading1': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '700',
      lineHeight: '1.2',
      fontSize: '32px'
    },
    'display-heading2': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '1.2',
      fontSize: '24px',
      fontWeight: '300'
    },
    'display-heading3': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      lineHeight: '1.2',
      fontSize: '22px'
    },
    'display-heading4': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '1.2',
      fontSize: '20px',
      fontWeight: '600'
    },
    'display-heading5': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '1.2',
      fontSize: '16px',
      fontWeight: '600'
    },
    'display-heading6': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      lineHeight: '1.2',
      fontSize: '14px',
      fontWeight: '600'
    },
    'display-tagline': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '700',
      fontSize: '55px',
      lineHeight: '1.2'
    },
    'display-page-heading': {
      fontSize: '20px',
      lineHeight: '1.2',
      fontWeight: '600',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif'
    }
  },
  border: {
    'alert-danger': '1px solid #F8A9AD',
    'alert-info': '1px solid #7fd1de',
    'alert-warning': '1px solid #FAE0B5',
    'alert-success': '1px solid #7FDED2',
    'alert-tip': '1px solid #7fd1de',
    'tile-default': '1px solid #CBD6E2',
    default: '1px solid #CBD6E2',
    subtle: '1px solid #DFE3EB',
    'input-default': '1px solid #CBD6E2'
  },
  boxShadow: {
    'alert-floating': '0 1px 4px 2px rgba(66, 91, 118, 0.06)',
    card: '0 1px 5px 0 rgba(45, 62, 80, 0.12)'
  },
  fontSize: {
    'button-default': '14px',
    'button-small': '12px',
    'button-extra-small': '12px',
    'icon-button-default': '18px',
    'icon-button-small': '16px',
    'icon-button-extra-small': '12px',
    'type-scale-body-default': '14px',
    'type-scale-body-small': '12px',
    'type-scale-body-medium': '14px',
    'type-scale-body-large': '16px',
    'type-scale-display-heading1': '32px',
    'type-scale-display-heading2': '24px',
    'type-scale-display-heading3': '22px',
    'type-scale-display-heading4': '20px',
    'type-scale-display-heading5': '16px',
    'type-scale-display-heading6': '14px',
    'type-scale-code-default': '14px'
  }
};